import { hexColorWithAlpha } from "helpers/css";
import colors from "./colors";

export const boxshadows = {
  BoxShadowAlongBrand: `0 0.125rem 0 ${colors.ColorSneaker300}`,
  BoxShadowAlongGreyCard: `0 0.125rem 0.25rem 0 ${colors.ColorGray300}`,
  BoxShadowAlongSpace: `0 0 0.625rem 0 ${hexColorWithAlpha(
    colors.ColorSpace500,
    0.15,
  )}`,
  BoxShadowAlongSpaceAlpha70: `0 0 0.625rem 0 ${hexColorWithAlpha(
    colors.ColorSpace500,
    0.7,
  )}`,
  BoxShadowAlongGroupCard: `0 0.375rem 0.625rem 0 ${hexColorWithAlpha(
    colors.ColorSpace500,
    0.15,
  )}`,
};
